import {BehaviorSubject} from 'rxjs';
import {map, filter} from 'rxjs/operators';
import {uiMsg$} from '@/ui';

export const displayAllMarginPairsOrder$ = new BehaviorSubject<boolean>(true);

export interface FUMarginAllSymbols {
  type: 'margin-all-symbols';
  data: boolean;
}
uiMsg$
  .pipe(
    filter((o) => o.type === 'margin-all-symbols'),
    map((o: FUMarginAllSymbols) => o.data)
  )
  .subscribe((all) => displayAllMarginPairsOrder$.next(all));
